import React from 'react';
import { ReactTyped } from 'react-typed';

export default function PageHeader() {
  return (
    <div className='bg-center' style={{backgroundImage: `url('assats/images/bg.jpg')`, backgroundSize: 'cover' , marginTop: '-30px'}}>
         <div className='flex flex-col min-h-screen justify-center mt-24 z-10 relative'>
          <h1 className='text-white text-7xl md:text-8xl font-bold'>HI!</h1>
          <h1 className='text-[#80ed99] text-7xl md:text-8xl font-bold'>Mukund <ReactTyped 
          strings=
          {[
            'Hadiya',
            'Developer',
            'Designer',
        
            
          ]} 
          typeSpeed={60} 
          backSpeed={60} 
          loop /> </h1>
          <h1 className='text-white text-lg md:text-2xl font-sans tracking-[8px]'>FULL STACK WEB DEVELOPER</h1>
          <h1 className='text-[#80ed99] text-lg md:text-2xl font-sans tracking-[4px] mt-[30px] bg-[#14919b] w-fit self-center p-2 border-[1px] border-white rounded-3xl'><ReactTyped 
          strings=
          {[
            'FULL STACK ', 
            'MERN STACK',
            'ReactJS',
            'NodeJS',
            
          ]} 
          typeSpeed={40} 
          backSpeed={40} 
          loop />Developer</h1>
        </div>
    </div>
  );
}
